export default __webpack_public_path__ + "static/performance-82371ca334da33d7b5363404dc8ad755.png";